import TraceTail from "@tracetail/js";

// TraceTail browser-fingerprint helper.
//
// Produces a stable per-device visitorId used to recognise a returning device
// (post-login "name this device" screen + Settings > User Profile > My Devices).
//
// The keys below are domain-restricted PUBLISHABLE keys. TraceTail keys are meant
// to be visible in client code (they identify the account for billing / rate
// limiting and are locked to their domain in the dashboard), so hardcoding them
// here is intentional and mirrors how apiURL.js / the Turnstile sitekey are handled.

const TRACETAIL_KEYS = {
  local: "tt_f74a12021020ddaaf973753ee884315f0294e20747ca364e6c4c0d18344d3432",
  app: "tt_9e8a9c221594f8afdaed71cc2851b4d387e6d52df44ad6060529a966c5dcbd1a",
  couk: "tt_d635773c43d0a0b29345999788f97eb46786e589a94453417215587efd4397f0",
};

function resolveApiKey() {
  const host =
    typeof window !== "undefined" ? window.location.hostname || "" : "";

  if (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "10.0.2.2" ||
    host.endsWith(".local") ||
    /^(192\.168\.|10\.|172\.(1[6-9]|2\d|3[0-1])\.)/.test(host)
  ) {
    return TRACETAIL_KEYS.local;
  }
  if (host.endsWith("crmit.co.uk")) return TRACETAIL_KEYS.couk;
  // Everything else (portal / prod / dev* / qa*) lives under crmit.app.
  return TRACETAIL_KEYS.app;
}

let _client = null;
function getClient() {
  if (_client) return _client;
  _client = new TraceTail({
    apiKey: resolveApiKey(),
    endpoint: "https://tracetail.io/api",
  });
  return _client;
}

// Returns { visitorId, confidence } or null on any failure.
// Never throws: a fingerprint problem must not block a user from logging in.
export async function getDeviceFingerprint() {
  try {
    const result = await getClient().generateFingerprint();
    if (!result || !result.visitorId) return null;
    return {
      visitorId: result.visitorId,
      confidence: result.confidence != null ? result.confidence : null,
    };
  } catch (err) {
    console.warn("TraceTail fingerprint failed", err);
    return null;
  }
}

// Best-effort friendly name from the user-agent, used to prefill the naming screen.
export function guessDeviceName() {
  const ua =
    typeof navigator !== "undefined" ? navigator.userAgent || "" : "";

  const browser = /Edg\//.test(ua)
    ? "Edge"
    : /OPR\//.test(ua)
    ? "Opera"
    : /Chrome\//.test(ua)
    ? "Chrome"
    : /Firefox\//.test(ua)
    ? "Firefox"
    : /Safari\//.test(ua)
    ? "Safari"
    : "Browser";

  const os = /Windows/.test(ua)
    ? "Windows"
    : /Macintosh|Mac OS X/.test(ua)
    ? "Mac"
    : /Android/.test(ua)
    ? "Android"
    : /iPhone|iPad|iPod/.test(ua)
    ? "iOS"
    : /Linux/.test(ua)
    ? "Linux"
    : "this device";

  return `${browser} on ${os}`;
}
